export default __webpack_public_path__ + "static/media/added-wishlist-icon.0bf26858.svg";